<template>
  <div class="site-header-root">
  <header id="siteHeader" ref="header" class="site-header" :class="{ scrolled: scrolled || !isHomepage, 'sub-header': !isHomepage, 'menu-open': menuOpen }">
    <div class="container nav-inner">
      <router-link to="/" class="brand" :aria-label="$t('site.company')" @click.native="closeMenu">
        <img src="@/assets/images/logo.png" :alt="$t('site.brand')" class="brand-logo">
        <span class="brand-text"><strong>{{ $t('site.brand') }}</strong></span>
      </router-link>
      <nav id="mainNav" class="main-nav" :class="{ open: menuOpen }" :aria-label="$t('site.navigation')">
        <a v-for="id in sections" :key="id" :href="'#/?section=' + id" class="nav-link" :class="{ active: isHomepage && activeSection === id }" @click.prevent="navigate(id)">{{ $t('site.' + id) }}</a>
        <router-link to="/signup" class="btn btn-primary nav-cta" @click.native="closeMenu">{{ $t('site.signup') }}</router-link>
      </nav>
      <div class="header-actions">
        <button type="button" class="btn btn-primary nav-download" @click="openDownloadDialog">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v12m-4-4 4 4 4-4M5 9H3v11h18V9h-2" /></svg>
          {{ $t('site.download') }}
        </button>
        <div class="lang-switch" role="group" :aria-label="$t('site.language')">
          <button type="button" class="lang-btn" :class="{ active: $i18n.locale === 'zh' }" :aria-pressed="$i18n.locale === 'zh'" @click="changeLanguage('zh')">中文</button>
          <button type="button" class="lang-btn" :class="{ active: $i18n.locale === 'mn' }" :aria-pressed="$i18n.locale === 'mn'" @click="changeLanguage('mn')">Монгол</button>
        </div>
        <button type="button" class="nav-toggle" :class="{ open: menuOpen }" :aria-label="$t(menuOpen ? 'site.menuClose' : 'site.menuOpen')" :aria-expanded="menuOpen" aria-controls="mainNav" @click="menuOpen = !menuOpen"><span></span><span></span><span></span></button>
      </div>
    </div>
    <button v-if="menuOpen" type="button" class="nav-backdrop" :aria-label="$t('site.menuClose')" @click="closeMenu"></button>
  </header>
    <!-- Keep the fixed dialog outside the header's backdrop-filter containing block. -->
    <div v-if="downloadDialogOpen" class="download-modal-mask" @click.self="closeDownloadDialog">
      <section ref="downloadDialog" class="download-modal" role="dialog" aria-modal="true" :aria-labelledby="'downloadDialogTitle'" tabindex="-1">
        <button type="button" class="download-modal-close" :aria-label="$t('site.downloadDialogClose')" @click="closeDownloadDialog">×</button>
        <h2 id="downloadDialogTitle">{{ $t('site.downloadDialogTitle') }}</h2>
        <p class="download-modal-intro">{{ $t('site.downloadDialogIntro') }}</p>
        <div class="download-qr-wrap">
          <img v-if="qrCodeData" :src="qrCodeData" :alt="$t('site.downloadQrAlt')" class="download-qr">
          <p v-else class="download-qr-loading">{{ $t(qrCodeFailed ? 'site.downloadQrFailed' : 'site.downloadQrLoading') }}</p>
        </div>
        <p class="download-link-label">{{ $t('site.downloadLinkLabel') }}</p>
        <a class="download-url" :href="downloadUrl" download="eruul.apk">{{ downloadUrl }}</a>
        <p class="download-tip">{{ $t('site.downloadBrowserTip') }}</p>
        <button type="button" class="btn btn-primary download-copy" @click="copyDownloadLink">
          {{ $t(linkCopied ? 'site.downloadCopied' : 'site.downloadCopy') }}
        </button>
      </section>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcode'
// Explicit loader also works with development servers started before the APK rule was added.
// eslint-disable-next-line import/no-webpack-loader-syntax
import apkUrl from '!!file-loader?name=static/apk/[name].[hash:7].[ext]!../assets/apk/eruul.apk'
export default {
  name: 'SiteHeader',
  data () {
    return {
      apkUrl,
      menuOpen: false,
      downloadDialogOpen: false,
      downloadUrl: '',
      qrCodeData: '',
      qrCodeFailed: false,
      linkCopied: false,
      scrolled: false,
      activeSection: 'home',
      sections: ['home', 'about', 'services', 'capability', 'partners', 'contact']
    }
  },
  computed: { isHomepage () { return this.$route.path === '/' } },
  watch: {
    menuOpen () { this.updateBodyLock() },
    downloadDialogOpen () { this.updateBodyLock() },
    '$route' () { this.closeMenu(); this.$nextTick(this.onScroll) }
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll, { passive: true })
    window.addEventListener('resize', this.onResize)
    window.addEventListener('keydown', this.onKeydown)
    this.onScroll()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.onResize)
    window.removeEventListener('keydown', this.onKeydown)
    document.body.style.overflow = ''
  },
  methods: {
    closeMenu () { this.menuOpen = false },
    updateBodyLock () { document.body.style.overflow = this.menuOpen || this.downloadDialogOpen ? 'hidden' : '' },
    onResize () { if (window.innerWidth > 1280) this.closeMenu() },
    onKeydown (event) {
      if (event.key !== 'Escape') return
      if (this.downloadDialogOpen) this.closeDownloadDialog()
      else this.closeMenu()
    },
    async openDownloadDialog () {
      this.closeMenu()
      this.downloadUrl = new URL(this.apkUrl, window.location.href).href
      this.downloadDialogOpen = true
      this.linkCopied = false
      this.qrCodeData = ''
      this.qrCodeFailed = false
      try {
        this.qrCodeData = await QRCode.toDataURL(this.downloadUrl, {
          errorCorrectionLevel: 'M',
          margin: 1,
          width: 260,
          color: { dark: '#0F3050', light: '#FFFFFF' }
        })
      } catch (error) {
        this.qrCodeFailed = true
      }
      this.$nextTick(() => { if (this.$refs.downloadDialog) this.$refs.downloadDialog.focus() })
    },
    closeDownloadDialog () {
      this.downloadDialogOpen = false
      this.linkCopied = false
    },
    async copyDownloadLink () {
      try {
        if (navigator.clipboard && window.isSecureContext) await navigator.clipboard.writeText(this.downloadUrl)
        else {
          const input = document.createElement('textarea')
          input.value = this.downloadUrl
          input.setAttribute('readonly', '')
          input.style.position = 'fixed'
          input.style.opacity = '0'
          document.body.appendChild(input)
          input.select()
          document.execCommand('copy')
          document.body.removeChild(input)
        }
        this.linkCopied = true
      } catch (error) {
        this.linkCopied = false
      }
    },
    onScroll () {
      this.scrolled = window.pageYOffset > 40
      if (!this.isHomepage) return
      const threshold = this.$refs.header.offsetHeight + 80
      let active = 'home'
      this.sections.forEach(id => { const el = document.getElementById(id); if (el && el.getBoundingClientRect().top <= threshold) active = id })
      this.activeSection = active
    },
    navigate (id) {
      this.closeMenu()
      if (this.isHomepage && (this.$route.query.section || 'home') === id) {
        const target = document.getElementById(id)
        if (target) window.scrollTo({ top: id === 'home' ? 0 : target.getBoundingClientRect().top + window.pageYOffset - this.$refs.header.offsetHeight + 1, behavior: 'smooth' })
      } else this.$router.push({ path: '/', query: { section: id } })
    },
    changeLanguage (language) {
      this.$i18n.locale = language
      this.$store.commit('setLanguage', language)
      try { localStorage.setItem('eruul-language', language) } catch (e) { /* Private browsers may disable storage. */ }
      this.$nextTick(this.onScroll)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layout/index.vue